import React, { useEffect } from 'react';
import { useHub } from '@4r/module-common-signalr';
import { getService } from '@4r/mf-app';
import { UserOrdersHub } from '../hubs/UserOrdersHub';
import MessageBusEvent from '../services/MessageBusEvents';

/**
 * Passes `NotifyBookingChanged` from the host's SignalR connection to the
 * microfrontends as `MessageBusEvent.BookingChanged`.
 *
 * The host no longer keeps order data — work-order owns the offline store and
 * decides what a booking change means for it (a newly booked order joins the
 * route). The connection stays here: one socket for the whole app, and a hub
 * context the microfrontends' own copies of the SignalR module cannot reach.
 * `useHub` yields the hub only while it is connected, which the host allows
 * only online.
 */
const SignalRUpdatesProvider: React.FunctionComponent = ({ children }) => {
	const hub = useHub(UserOrdersHub);

	useEffect(() => {
		if (!hub) return undefined;
		const unsubscribe = hub.onNotifyBookingChanged((message) => {
			getService('MessageBusService')?.emit(MessageBusEvent.BookingChanged, message);
		});
		return () => unsubscribe?.();
	}, [hub]);

	return <>{children}</>;
};

export default SignalRUpdatesProvider;
